import Skeleton from 'react-loading-skeleton';

const WishlistSkeleton = () => {
  return (
    <div className="flex flex-col lg:flex-row lg:items-start lg:gap-26 lg:px-20 lg:py-48 xl:px-48">
      <div className="bg-white px-16 py-12 md:px-24 md:py-12 lg:w-full lg:rounded-md lg:px-20 lg:py-36 xl:px-48">
        <div className="relative mb-10 h-full w-full">
          <div className="relative mb-10 h-[32px] w-full md:w-[25%]">
            <Skeleton className="h-full"></Skeleton>
          </div>
        </div>
        <div className="relative mb-10 mt-24 h-full w-full border-b">
          <div className="flex justify-between">
            <div className="relative mb-10 h-[24px] w-full md:w-[30%]">
              <Skeleton className="h-full"></Skeleton>
            </div>
            <div className="relative mb-10 h-[24px] md:w-[50px]">
              <Skeleton className="h-full"></Skeleton>
            </div>
          </div>
          <div className="relative mb-10 h-[16px] w-[20%]">
            <Skeleton />
          </div>
        </div>
        <div className="relative mb-10 mt-24 h-full w-full">
          <div className="flex justify-between">
            <div className="relative mb-10 h-[24px] w-full md:w-[30%]">
              <Skeleton className="h-full"></Skeleton>
            </div>
            <div className="relative mb-10 h-[24px] md:w-[50px]">
              <Skeleton className="h-full"></Skeleton>
            </div>
          </div>
          <div className="relative mb-10 h-[16px] w-[20%]">
            <Skeleton />
          </div>
        </div>
        <div className="relative mb-10 ml-auto mt-24 h-full w-[20%]">
          <Skeleton />
        </div>
        <div className="relative mx-auto mb-10 mt-24 h-full w-[10%]">
          <Skeleton />
        </div>
      </div>
    </div>
  );
};

export default WishlistSkeleton;
